import { styled } from 'linaria/lib/react';
import { StyledSubtitle } from 'components/UI/ContentSubtitle/styled';
import StyledTitle from 'components/UI/ContentTitle/styled';
import { COLORS, FONTS } from 'styles/constants';
import { StyledInfoContainer } from 'components/Onboarding/Layout/styled';

export const StyledWrap = styled.div<{ maxWidth?: number }>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100dvh - var(--keyboard-offset));
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : '390px')};
  min-width: 383px;
  margin: 0 auto;
  overflow-y: visible;
  overflow-x: visible;
  padding: 0 12px 45px 12px;
  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }

  .swiper {
    margin: 0;
    padding-top: 0;
  }
`;

export const StyledPageInfoContainer = styled(StyledInfoContainer)<{ isPaddingBottom?: boolean }>`
  padding: 10px 18px ${({ isPaddingBottom }) => (isPaddingBottom ? '26' : '32')}px;
  max-width: 100%;
`;

export const StyledContent = styled.section<{ isDark: boolean }>`
  border-top: 1px solid ${({ isDark }) => (isDark ? COLORS.white[30] : COLORS.brown.dark[10])};
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  align-items: center;
`;

export const StyledTextContainer = styled.div`
  text-align: center;
  padding: 16px 32px;
`;

export const StyledMainInfo = styled(StyledTitle)`
  color: ${({ isDark }) => (isDark ? COLORS.white[100] : COLORS.brown.dark[100])};
  padding: 0 8px 8px;
`;

export const StyledInfo = styled(StyledSubtitle)`
  color: ${({ isDark }) => (isDark ? COLORS.white[100] : COLORS.brown.dark[100])};
  padding: 0 8px 8px;
`;

export const StyledButtonContainer = styled.div`
  margin: auto auto 0;
  max-width: 390px;
  width: 100%;

  & > button {
    width: 100%;
  }
`;

export const StyledButton = styled.button`
  align-items: center;
  background-color: ${COLORS.brown.dark[100]};
  border: none;
  border-radius: 100px;
  box-shadow: 0px 11px 6px ${COLORS.black[10]}, 0px 5px 5px ${COLORS.black[20]}, 0px 1px 3px ${COLORS.black[20]},
    0px 0px 0px ${COLORS.black[20]};
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: 58px;
  padding: 0;
  width: 58px;

  path {
    stroke: ${COLORS.white[100]};
  }
`;

export const StyledBottomMenu = styled.div<{ bottom?: number }>`
  bottom: ${({ bottom }) => bottom || 42}px;
  display: flex;
  left: 50%;
  max-width: calc(100% - 24px);
  position: fixed;
  transform: translateX(-50%);
  width: max-content;
  z-index: 100;
`;

export const StyledFloatingMenu = styled.div`
  display: flex;
  padding: 4px;
  align-items: flex-start;
  gap: 2px;

  position: fixed;
  left: 50%;
  bottom: 12px;
  transform: translateX(-50%);

  border-radius: 999px;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(2.5px);
  z-index: 999;
`;

export const StyledFloatingButton = styled.button<{ isSelected?: boolean }>`
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border: none;
  background: transparent;
  border-radius: 22px;
  cursor: pointer;
  color: ${({ isSelected }) => (isSelected ? COLORS.white[100] : COLORS.brown.dark[100])};
  background: ${({ isSelected }) => (isSelected ? COLORS.brown.dark[100] : 'transparent')};
`;

export const StyledSearchOverlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  left: 50%;
  bottom: 0;
  width: 100%;
  max-width: 504px;
  height: ${({ isOpen }) => (isOpen ? 'calc(100dvh - 27px)' : '0')};
  border-radius: 20px 20px 0 0;
  background: var(--dark-brown, #181800);
  transition: height 220ms ease-in-out;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`;

export const StyledSearchControls = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 24px 0 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  background: var(--dark-brown, #181800);
`;

export const StyledSearchField = styled.div`
  display: flex;
  width: 100%;
  padding: 10px 20px 10px 12px;
  align-items: center;
  align-self: stretch;
  gap: 4px;
  border-radius: 22px;
  background: var(--transparencies-white-10, rgba(255, 255, 255, 0.1));
  backdrop-filter: blur(2px);
`;

export const StyledSearchInput = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  font-family: ${FONTS.secondary};
`;

export const StyledSearchIcon = styled.span`
  display: flex;
  align-items: center;
  align-self: stretch;
  color: ${COLORS.white[100]};
`;
